import Badge from "../../../../../../../components/badge/badge";
import CopyToClipboard from "../../../../../../../components/copyToClipboard";
import Button from "../../../../../../../components/button";
import {
    BanIcon, CrossIcon,
    Dots,
    EyeIcon,
    Localisation,
    Plus,
    Star,
    SwitchIcon
} from "../../../../../../../assets/icons";
import UseContext from "../../../../../../../hooks/useContext";
import useModal from "../../../../../../../components/modal/useModal";
import useSlideOver from "../../../../../../../components/SlideOver/useSlideOver";
import {useNavigate} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import DropdownMenu from "../../../../../../../components/DropdownMenu/DropdownMenu";
import TableRow from "../../../../../../../components/table/components/TableRow";

const TbodyFicheVivier = ({champsBody, setAddVivier, list, idVivier, isExclude, selectedId, setSelectedId}) => {

    const { setInfoVivier, setAdminLink, setAdminType, setAdminTempWorkerId } = UseContext()
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropDownRef = useRef(null);
    const { toggle } = useModal()
    const {objID, setObjID}=UseContext()
    const {toggleSlideOver} = useSlideOver();
    const navigate = useNavigate();
    const urlParams = new URLSearchParams(window.location.search);
    const idTempWorker = urlParams.get('idTempWorker');

    const handleCheckboxChange = (id) => {
        // Vérifiez si la case à cocher d'en-tête est cochée pour décider de l'état des cases à cocher individuelles
        const checked = list.includes(id);

        // Mettez à jour l'état de la case à cocher individuelle
        if (checked) {
            setAddVivier(list.filter((item) => item !== id));
        } else {
            setAddVivier([...list, id]);
        }
    };

    useEffect(() => {
        let handler = (e) => {
            if (!dropDownRef.current.contains(e.target)) {
                setDropdownOpen(false)
            }
        }
        document.addEventListener("mousedown", handler)

        return () => {
            document.removeEventListener("mousedown", handler)
        }
    }, [])

    const openTempWorkerInfo = (id) => {
        setObjID(id)
        setSelectedId(id)
        toggleSlideOver('get_temp_worker')
        navigate('/ficheVivier/'+ idVivier +'?idTempWorker=' + id);
    }

    useEffect(() => {
        if(idTempWorker) {
            if(!objID){
                openTempWorkerInfo(idTempWorker)
            } else {
                if(idTempWorker !== objID) {
                    openTempWorkerInfo(idTempWorker)
                }
            }
        }
    }, [idTempWorker]);

    const openDocument = (type, uri) => {
        setAdminLink(uri);
        setAdminType(type);
        setAdminTempWorkerId('');
        toggle('ad_file_view');
    }

    const excludeAgencySelected = (idUser) => {
        setInfoVivier({listUsers: [idUser]})
        toggle("exclude_agency")
    }

    const addVivierSelected = (idUser) => {
        setInfoVivier({listUsers: [idUser]})
        toggle("vivier_add")
    }

    const changeLocalisation = (idUser) => {
        setInfoVivier({listUsers: [idUser]})
        toggle("localisation_preferences")
    }

    const excludeVivier = (idUser) => {
        setInfoVivier({
            idVivier: idVivier,
            nameUser: champsBody.firstname + " " + champsBody.lastname,
            listUsers: [idUser]
        })
        toggle("vivier_delete_candidate")
    }

    const changeUserVivierStatus = (idUser) => {
        setInfoVivier({
            idVivier: idVivier,
            listUsers: [idUser]
        })
        toggle("vivier_change_status")
    }

    const handleDropDown = () => {
        setDropdownOpen(prev => !prev);
    }

    return (
        <>
            {!champsBody?.isDeleted && (
                <TableRow
                    key={champsBody._id}
                    itemId={champsBody._id}
                    selectedId={selectedId}
                    onClick={(id) => openTempWorkerInfo(id)}
                >
                    <td className="py-5 pl-4 md:pl-8 pr-2 min-w-[280px]">
                        <div className='flex items-center gap-4' onClick={(e) => {
                            e.stopPropagation();
                            handleCheckboxChange(champsBody._id);
                        }}>
                            <input type="checkbox" checked={list?.includes(champsBody._id)} readOnly={true}/>
                            <div>
                                <div className='text-sm text-gray-900 flex gap-1 items-center'>
                                    <div className='truncate'>
                                        {champsBody.firstname} {champsBody.lastname}
                                    </div>
                                    <div className='text-gray-500 text-xs flex-shrink-0'>
                                        <CopyToClipboard text={champsBody.id_bestt}>
                                            (N° {champsBody.id_bestt})
                                        </CopyToClipboard>
                                    </div>
                                </div>
                                <div className='flex gap-4'>
                                    {champsBody.token_refresh_mobile ? <Badge type={'APP'}>App</Badge> : ""}
                                    {champsBody.token_refresh ? <Badge type={'WEB'}>Web</Badge> : ""}
                                </div>
                            </div>
                        </div>
                    </td>
                    {idVivier !== '64e8cfd10b4f73f442432c9f' && (
                        <td className="py-5 px-2 min-w-[100px]">
                            {(champsBody.rating || champsBody.rating === 0) ? (
                                <div className={'my-auto border rounded-full flex gap-1 px-1.5 w-fit'}>
                                    <div className={'my-auto'}>
                                        <Star wh={18} color={'#FF9600'}/>
                                    </div>
                                    <div className={'my-auto'}>
                                        {champsBody.rating}
                                    </div>
                                </div>
                            ) : (
                                <div className={'text-sm text-gray-500'}>
                                    Non noté
                                </div>
                            )}
                        </td>
                    )}
                    <td className="py-5 px-2 min-w-[200px]">
                        {champsBody.phone ?
                            <CopyToClipboard text={champsBody.phone}>
                                <span className='text-sm text-gray-700'>
                                    {champsBody.phone}
                                </span>
                            </CopyToClipboard>
                            : null
                        }
                        {
                            champsBody.email ?
                                <CopyToClipboard text={champsBody.email}>
                                    <span className='text-sm text-gray-500'>
                                        {champsBody.email}
                                    </span>
                                </CopyToClipboard>
                                : null
                        }
                    </td>
                    {!isExclude && (
                        <td className="py-5 px-2 min-w-[120px] max-w-[180px]">
                            <p className="truncate text-sm text-gray-500">
                                {champsBody?.viviers?.join("/ ")}
                            </p>
                        </td>
                    )}
                    <td className="py-5 pl-2 pr-4 md:pr-8">
                        <div className={'flex items-center gap-2 justify-end'}>
                            {!isExclude && (
                                <div className={'cursor-pointer w-9 h-9 flex items-center justify-center rounded hover:bg-gray-100'} onClick={(e) => {
                                    e.stopPropagation();
                                    openTempWorkerInfo(champsBody?._id);
                                }}>
                                    <EyeIcon wh={20} color={'#374151'}/>
                                </div>
                            )}
                            <div className={'relative cursor-pointer w-9 h-9 flex items-center justify-center rounded hover:bg-gray-100'} ref={dropDownRef} onClick={(e) => {
                                e.stopPropagation();
                                handleDropDown();
                            }}>
                                <Dots w={14} h={4} color={'#374151'}/>
                                {dropdownOpen && (
                                    <div className="absolute right-8 -bottom-8 z-[9999]">
                                        <DropdownMenu
                                            width="w-56"
                                            items={[
                                                {
                                                    icon: Plus,
                                                    label: 'Ajouter dans un vivier',
                                                    onClick: () => addVivierSelected(champsBody?._id)
                                                },
                                                {
                                                    icon: Localisation,
                                                    label: 'Modifier la localisation',
                                                    onClick: () => changeLocalisation(champsBody?._id)
                                                },
                                                ...(champsBody.vivier_status !== 'archive' ? [
                                                    { separator: true },
                                                    {
                                                        icon: SwitchIcon,
                                                        label: 'Déplacer de colonne',
                                                        onClick: () => changeUserVivierStatus(champsBody?._id)
                                                    }
                                                ] : []),
                                                { separator: true },
                                                {
                                                    icon: CrossIcon,
                                                    label: 'Supprimer du vivier',
                                                    onClick: () => excludeVivier(champsBody?._id)
                                                },
                                                ...(!isExclude ? [{
                                                    icon: BanIcon,
                                                    label: 'Exclure de l\'agence',
                                                    onClick: () => excludeAgencySelected(champsBody?._id),
                                                    iconColor: '#DC2626',
                                                    className: 'text-red-500'
                                                }] : [])
                                            ]}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </td>
                </TableRow>
            )}
        </>
    )
}

export default TbodyFicheVivier;